export default "__VITE_ASSET__BQJnwjnD__"